module.exports = __webpack_public_path__ + "72b7bbd593e05268f463f82ceadd2687.svg";